const locale = {
  common_ok: "Confirm",
  common_cancel: "Cancel",
  im_selected_invalid_date:
    "Sorry, the date you have selected is invalid,Please reselect.",
  copy_success: "Copy success",
  please_select_time: "Please select a time",
  person_list: "Member list",
};

export default locale;
